(function($, window, undefined) {
  if (window.mg === undefined)
    window.mg = {};

  if (window.mg.ui === undefined)
    window.mg.ui = {};

  const _ = window.mg;

  const defaults = {
    returnFocus   : true,
    onClear       : null,
    hideOnBlur    : true,
    clearOnEscape : true
  };

  class Clearer {
    constructor(input, options) {
      this._$input  = $(input);
      this._options = $.extend({}, defaults, options);

      return this._$input.data('ui.clearer') || this.init();
    }

    init() {
      if (this._$input.data('ui.clearer'))
        return this;

      this._$clearer = $('<i class="clearer icon icon-close" aria-hidden="true"></i>');
      this._$input.wrap('<div class="form-control-clearer-wrapper"></div>');
      this._$input.after(this._$clearer);
      this._$input.data('ui.clearer', this);

      this._$input.on('focus.clearer', (e) => {
        if (this._$input.val().length >= 1)
          this.update(true);
      });

      this._$input.on('blur.clearer', (e) => {
        if (this._options.hideOnBlur === true) {
          setTimeout(() => {
            this.update(false);
          }, 50);
        }
      });

      this._$input.on('keyup.clearer', (e) => {
        if (this._options.clearOnEscape === true && e.which === 27) {
          this._$input.val('');

          if (this._options.onClear)
            this._options.onClear(this._$input);
        }

        this.update(this._$input.val().length >= 1);
      });

      this._$input.on('input.clearer change.clearer paste.clearer', (e) => {
        this.update(this._$input.val().length >= 1);
      });

      this._$clearer.on('mousedown.clearer', (e) => {
        e.preventDefault();
      });

      this._$clearer.on('click.clearer', (e) => {
        this._$input.val('');
        this.update(false);

        if (this._options.returnFocus === true)
          this._$input.focus();

        if (this._options.onClear)
          this._options.onClear(this._$input);

        e.preventDefault();
      });

      return this;
    }

    update(status) {
      this._$clearer.attr('data-active', status ? '1' : '0');

      return this;
    }

    destroy() {
      return Clearer.destroy(this._$input);
    }

    static destroy(input) {
      const $input   = $(input);
      const instance = $input.data('ui.clearer');

      if (!instance)
        console.warn('The clearer is not initialised');

      instance._$input.off('.clearer');
      instance._$input.unwrap('.form-control-clearer-wrapper');
      instance._$input.removeData('ui.clearer');

      instance._$clearer.off('.clearer');
      instance._$clearer.remove();

      return instance;
    }
  }

  _.ui.clearer         = (input, options) => new Clearer(input, options);
  _.ui.clearer.destroy = (input) => Clearer.destroy(input);
})(jQuery, window);
